import React from 'react'
import documentoPdf from '../../assets/files/Concurso/LISTADO DEFINITIVO DE ASPIRANTES SELECCIONADOS 26.pdf'
import { SecurePDFViewer } from '../../components/SecurePDFViewer'

const ConcursoListadoProvViewer = () => {
  return (
    <SecurePDFViewer pdfUrl={documentoPdf} />
  )
}

export { ConcursoListadoProvViewer }